import { Navigate } from "react-router-dom";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/index/home";
import SearchService from "../pages/services-List/page";
import ServicePage from "../pages/service-detail/page";
import RegisterBusiness from "../pages/businessForm/registerBusiness";
import Error from "../pages/others/error";
import Contact from "../pages/contact-us/page";
import AboutUs from "../pages/about-us/page";
import Service1 from "../pages/services-description/services1";
import Service2 from "../pages/services-description/services2";
import Service3 from "../pages/services-description/services3";
import Service4 from "../pages/services-description/services4";
import RegisterAccount from "../pages/createAccount/createAccount";
import { MerchantAboutUs } from "../pages/merchantLandingPage/merchantLandingPage";
import { ClientFAQ } from "../pages/client-faq/page";
import { Refund } from "../pages/static-page/refund";
import { PrivacyPolicy } from "../pages/static-page/privacyPolicy";
import { ContractorAgreement } from "../pages/static-page/contractorAgreement";
import { SoleProprietorShip } from "../pages/static-page/soleProprietor";
import { TermsOfService } from "../pages/static-page/termsOfService";
import { WebsiteTermsOfUse } from "../pages/static-page/websiteTermsOfUse";
import ConsentForm from "../pages/static-page/consentForm";
import Payment from "../pages/stripe-payment/payment";
import Success from "../pages/others/success";
import Fail from "../pages/others/fail";
import BusinessRegistrationSuccess from "../pages/others/businessSuccessfulRegistration";
import CreatePassword from "../components/createPassword";
import { LoadStripeCard } from "../pages/saveCard/page";
import AppointmentSuccess from "../pages/appointmentSuccess/page";
import BusinessEmailVerificationReminder from "../pages/businessEmailVerifyReminder/page";
import UserProfile from "../pages/profile/page"
import UserBookings from "../pages/appointments/page"

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/create-account" element={<RegisterAccount />} />
      <Route path="/serviceList" element={<SearchService />} />
      <Route path="/service" element={<ServicePage />} />
      {/* <Route path='/service/:id' element={<ServicePage />} /> */}
      <Route path="/practitioner-register" element={<RegisterBusiness />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/about-service" element={<MerchantAboutUs />} />
      <Route path="/payment" element={<Payment />} />
      <Route path="/business/create-password" element={<CreatePassword />} />
      <Route path="/save-card" element={<LoadStripeCard />} />
      <Route path="/user/profile" element={<UserProfile />} />
      <Route path="/user/bookings" element={<UserBookings />} />
      <Route
        path="/business-registration-success"
        element={<BusinessRegistrationSuccess />}
      />
      <Route
        path="/business-email-verification-reminder"
        element={<BusinessEmailVerificationReminder />}
      />

      {/* SERVICES */}
      <Route path="/service/physiotherapy" element={<Service1 />} />
      <Route path="/service/chiropractic" element={<Service2 />} />
      <Route path="/service/massage" element={<Service3 />} />
      <Route path="/service/acupuncture" element={<Service4 />} />

      {/* STATIC PAGES */}
      <Route path="/appointment-success" element={<AppointmentSuccess/> } />
      <Route path="/payment" element={<Payment />} />
      <Route path="/404" element={<Error />} />
      <Route path="/paymentSuccess" element={<Success />} />
      <Route path="/paymentFailed" element={<Fail />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/faq" element={<ClientFAQ />} />
      <Route path="/refund-&-cancellation" element={<Refund />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-use" element={<WebsiteTermsOfUse />} />
      <Route path="/consent-form" element={<ConsentForm />} />
      <Route path="/contractor-agreement" element={<ContractorAgreement />} />
      <Route path="/sole-proprietorship" element={<SoleProprietorShip />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
}
